import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { change } from 'redux-form'
import {
  addCssClass,
  removeCssClass
} from '../../../../utilities/function/common'

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse,
  isResponseCancelled,
} from '../../../../utilities/function/apiResponse'

import {updatePopupNotification} from '../../../../app/action'

import CONFIG_API, { cancelAutoComplete } from '../../../../utilities/api/config'
import {renderLabel} from './index'

let AddressField = (props) => {
  const [autocomplete,disableAutocomplete] = useState(false)
  const {input, className, placeholder, type, meta, initialValue, optional,label} = props
  const {error, touched, dispatch, form} = meta
  const [optionalPlaceholder, setOptionalPlaceholder] = useState(false)

  const fieldRef = useRef(null)

  const initFlag = useRef(false)
  useEffect(() => {
    if (initFlag.current === false) {

      if (input.value) {
        setOptionalPlaceholder(false)
      } else {
        setOptionalPlaceholder(true)
      }
      initFlag.current = true
    }
  }, [optionalPlaceholder, input])

  const {name, onBlur, onFocus} = input
  const renderOptionalPlaceholder = () => {
    if (optionalPlaceholder) {
      if (optional && input && !input.value) {
        return (
          <div onClick={() => {
            setOptionalPlaceholder(false)
            if (fieldRef && fieldRef.current) {
              fieldRef.current.focus()
            }
          }} className={'of-textfield__placeholder text-font-4-100'}><span>{placeholder}</span> <i>(Optional)</i></div>
        )
      }
    }

    return (<></>)
  }

  useEffect(() => {
    dispatch(change(form, name, initialValue))
  }, [initialValue, dispatch, form, name])

  const isError = () => {
    return error && touched
  }

  const getErrorMessage = () => {
    return error
  }

  const [requestAutoComplete, setRequestAutoComplete] = useState({})

  const allform = useSelector(state => state.form)

  const [selectedPlaceID,setSelectedPlaceID] = useState(undefined)
  const [requestPlaceDetails, setRequestPlaceDetails] = useState({})
  const autoCompleteResultOnAction = (id,description) => {
    resetAddressResult()
    setRequestPlaceDetails({
      ...requestPlaceDetails,
      status: 'loading',
    })
    CONFIG_API.getPlaceDetails(id).then(successresponse=>{
      const data = getDataFromSuccessResponse(successresponse)
      if(data && data.result && data.result && data.result){
        const {address_components} = data.result
        if(address_components && address_components.length){
          const getComponentByCode = (code,field) => {
            let selected = null
            address_components.forEach((item)=>{
              const {types} = item
              if(types && Array.isArray(types) && types.length > 0){
                if(types.find(i=>i===code)){
                  selected =  item
                }
              }
            })
            if(selected && selected.long_name){
              dispatch(change(form,field,selected.short_name))
            }
          }
          const getStreet = () =>{
           if(description){
             let str = description.split(",")
             if(str && str.length>0){
               return str[0]
             }
             return str
           }
          }
          if(getStreet()){
            dispatch(change(form,'address',getStreet()))
          }
          getComponentByCode("locality",'city')
          getComponentByCode("postal_code",'postcode')
          getComponentByCode("country",'country')
          getComponentByCode("administrative_area_level_1",'state')
        }
      }
      setRequestPlaceDetails({
        ...requestPlaceDetails,
        status: 'success',
        data
      })
    },errorresponse=>{
      const error = getErrorFromFailResponse(errorresponse)
      updatePopupNotification(dispatch, {
        status: 'error',
        error
      })
      setRequestPlaceDetails({
        ...requestPlaceDetails,
        status: 'error',
        error
      })
    })
  }

  const searchAddress = () => {
    if (allform && form && allform[form] && allform[form].values && fieldRef.current && !autocomplete) {
      const {country} = allform[form].values
      if (fieldRef.current.value && country) {
        let keyword = fieldRef.current.value.replace(/\s/g, '+')
        keyword = encodeURI(keyword)
        setRequestAutoComplete({
          ...requestAutoComplete,
          status: 'loading'
        })
        if (cancelAutoComplete) {
          cancelAutoComplete()
        }
        CONFIG_API.getAutoComplete(keyword, country.toLowerCase()).then(successresponse => {
          const data = getDataFromSuccessResponse(successresponse)
          setRequestAutoComplete({
            ...requestAutoComplete,
            status: 'success',
            data
          })
        }, errorresponse => {
          const error = getErrorFromFailResponse(errorresponse)
          if (!isResponseCancelled(error)) {
            updatePopupNotification(dispatch, {
              status: 'error',
              error
            })
            setRequestAutoComplete({
              ...requestAutoComplete,
              status: 'error',
              error
            })
          }
        })
      }
    }
  }

  const resetAddressResult = () => {
    setRequestAutoComplete({})
  }

  const onEnterAddress = () => {
    if(selectedPlaceID){
      autoCompleteResultOnAction(selectedPlaceID.place_id,selectedPlaceID.description)
    }
  }


  const selectAddress = (up) =>{
    if(requestAutoComplete.data && requestAutoComplete.data.predictions
      && requestAutoComplete.data.predictions.length > 0){
      let selectedIndex = -1
      if(selectedPlaceID){
        requestAutoComplete.data.predictions.forEach((i,index)=>{
          if(i.place_id===selectedPlaceID.place_id){
            selectedIndex =  index
          }
        })
      }
      if(up){
        selectedIndex++
        if(selectedIndex>requestAutoComplete.data.predictions.length-1){
          selectedIndex = requestAutoComplete.data.predictions.length-1
        }
      }else{
        selectedIndex--
        if(selectedIndex<0){
          selectedIndex = 0
        }
      }
      const next = requestAutoComplete.data.predictions[selectedIndex]
      setSelectedPlaceID(next)
    }
  }


  const onKeyUp = (e) => {
    switch (e.which) {
      case 27:
        resetAddressResult()
        break
      case 40:
        selectAddress(true)
        break
      case 38:
        selectAddress(false)
        break
      case 13:
        onEnterAddress()
        break
      default:
        searchAddress()
        break
    }
  }


  const timeoutRef = useRef(null)
  const resultRef = useRef(null)

  const renderAutoCompleteResult = () => {
    if (requestAutoComplete && requestAutoComplete.status === 'success' && requestAutoComplete.data && !autocomplete) {
      const {predictions} = requestAutoComplete.data
      if (predictions && Array.isArray(predictions) && predictions.length > 0) {
        const renderList = () => {
          return predictions.map((item, index) => {
            const {description, place_id, structured_formatting} = item
            const renderDescription = () => {
              if (description && structured_formatting && structured_formatting.main_text_matched_substrings) {
                const {main_text_matched_substrings} = structured_formatting
                if (main_text_matched_substrings && Array.isArray(main_text_matched_substrings) && main_text_matched_substrings.length > 0) {
                  const matched = main_text_matched_substrings[0]
                  const matched_string = description.substring(0, matched.length)
                  const remaining_string = description.substring(matched.length, description.length)
                  if (matched_string) {
                    return (
                      <>
                        <strong>{matched_string}</strong>
                        <span>{remaining_string}</span>
                      </>
                    )
                  }
                }
                return (description)
              }
              return (<></>)
            }

            return (
              <div onClick={e=>{
                e.preventDefault()
                e.stopPropagation()
               /* if(timeoutRef.current){
                  window.clearTimeout(timeoutRef.current)
                }*/
                //timeoutRef.current = window.setTimeout(()=>{
                  autoCompleteResultOnAction(place_id,description)
                //},300)

              }} key={index} className={`of-textfield-autocomplete-result__item${selectedPlaceID && item.place_id===selectedPlaceID.place_id?' primary-background-1-100 of-textfield-autocomplete-result__item--selected':''}`}>
                <div className={'description'}>{renderDescription()}</div>
              </div>)
          })
        }
        return (
          <div className={'of-textfield-autocomplete-result'} ref={resultRef}>
            {renderList()}
            <div onClick={e=>{
              e.preventDefault()
              if(timeoutRef.current){
                window.clearTimeout(timeoutRef.current)
              }
              disableAutocomplete(true)
            }} className={`of-textfield-autocomplete-result__item`}>
              <div className={'description'}>I want to add manually</div>
            </div>
          </div>
        )
      }
    }
    return (<></>)
  }

  if (type === 'hidden') {
    return (<>
      <input {...input} type={type} className={`${className ? ' ' + className : ''}`} ref={fieldRef}
      />
      {isError() ? <div className={'of-textfield__error status-font-2-100'}>{getErrorMessage()}</div> : <></>}
    </>)
  }

  const clickaway = (e) => {
    if(resultRef && resultRef.current && resultRef.current !== e.target && !resultRef.current.contains(e.target)){
      resetAddressResult()
    }
  }

  return (
    <div className={`of-textfield${isError ? ' of-textfield--error' : ''}`}>
      {renderLabel(label,input.value)}
      <input {...input} type={type ? type : 'text'}
             className={`${isError() ? 'status-border-2-100' : 'lines-border-1-100'} of-textfield__input${className ? ' ' + className : ''}`}
             placeholder={optional ? null : placeholder}
             onFocus={(e) => {
               onFocus()
               removeCssClass(e.currentTarget, 'lines-border-1-100')
               addCssClass(e.currentTarget, 'primary-border-1-100')
               document.addEventListener("click",clickaway)
               document.addEventListener("touchstart",clickaway)
             }}
             onBlur={(e) => {
               removeCssClass(e.currentTarget, 'primary-border-1-100')
               addCssClass(e.currentTarget, 'lines-border-1-100')
               document.removeEventListener("click",clickaway)
               document.removeEventListener("touchstart",clickaway)
               onBlur()
               if (optional) {
                 setOptionalPlaceholder(true)
               }
             }}
             ref={fieldRef}
             onKeyUp={onKeyUp}
      />
      {renderOptionalPlaceholder()}
      {renderAutoCompleteResult()}
      {isError() ? <div className={'of-textfield__error status-font-2-100'}>{getErrorMessage()}</div> : <></>}
    </div>
  )
}

AddressField.propTypes = {
  input: PropTypes.any,
  label: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.any,
  initialValue: PropTypes.any,
  ref: PropTypes.any,
  optional: PropTypes.bool
}

export default AddressField